// Copyright (c) Microsoft Corporation. All rights reserved.
export const stringify = (input) => {
    // Objects generally don't have useful toString methods, except for Errors which do
    if (typeof input === 'object' && !(input instanceof Error)) {
        // So we stringify to JSON
        return JSON.stringify(input);
    }
    return String(input);
};
//# sourceMappingURL=stringify.js.map